import { useState } from "react";
import "../../Styles/Enquery.css";
import { Header } from "../Core/Header";
import {
  createJobEnquiry,
  sendOtpApi,
  UserCreateAPI,
  VerifyOtpApi,
  createPartnerShip,
  createProductEnquiry
} from "../Services/Operations/ProductAPI";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { Footer } from "../Core/Footer";

const EnqueryPage = () => {
  const [step, setStep] = useState(4);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [id, setId] = useState(1);
  const[coverLetter,setCoverLetter]=useState("");
  const [resume, setResume] = useState(null);
  const[reasonForPartnershipRequest,setReasonForPartnershipRequest]=useState("");
  const[produtEnquiry,setProdutEnquiry]=useState("");
  const[prescription,setPresription]=useState(null);
  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    dob: "",
    age: "",
    gender: "",
    co: "",
    houseBuildingApartment: "",
    streetRoadLane: "",
    landmark: "",
    areaLocalitySector: "",
    villageTownCity: "",
    postOffice: "",
    district: "",
    subDistrict: "",
    state: "",
    pincode: "",
    primaryNumber: "",
    secondaryNumber: "",
    email: "",
  });

  const [enquiryData, setEnquiryData] = useState(null);

  const handleSendPhone = async () => {
    if (!phone.match(/^\d{10}$/)) {
      toast.error("Please enter a valid 10-digit phone number.");
      return;
    }
    try {
      await sendOtpApi(phone);
      toast.success("OTP sent successfully!");
      setStep(2);
    } catch {
      toast.error("Failed to send OTP. Please try again.");
    }
  };

  const handleVerifyOtp = async () => {
    const fullOtp = otp.join("");
    if (fullOtp.length !== 4) {
      toast.error("Please enter the complete 4-digit OTP.");
      return;
    }

    try {
      const response = await VerifyOtpApi(phone, fullOtp);
      console.log("response : ", response);
      const isNewUser = !response?.userExists;

      toast.success("OTP verified successfully!");
      if (isNewUser)
         {
        setStep(3);
      } else {
        setEnquiryData({
          name: response.name || "John Doe",
          enquiry: response.enquiry || "T-shirt product enquiry",
        });
        setStep(4);
      }
    } catch {
      toast.error("Invalid OTP. Please try again.");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmitForm = async () => {
    try {
      const response = await UserCreateAPI(formData);
      console.log("User created successfully:", response);
      if (response.status === 1) {
        toast.success("Details submitted successfully!");
        setStep(4);
      }
    } catch (error) {
      console.error("User creation failed:", error);
      toast.error("Failed to submit details. Please try again.");
    }
  };

  const handleSubmitEnquiry=async()=>{
    try {
      const formData = new FormData();
  formData.append("coverLetter", coverLetter);
  formData.append("resume", resume);

      const response=await createJobEnquiry(formData)

      console.log("response after submittingjob",response);
      toast.success("Enquiry submitted successfully!");
      
    } catch (error) {
      console.error("Enquiry submission failed:", error);
      toast.error("Failed to submit enquiry. Please try again.");
    }
  }
 const handleProductEnquiry=async()=>{
    try {
      const formData = new FormData();
  formData.append("enquiry", produtEnquiry);
  formData.append("presription", prescription);
  formData.append("productId", id);

      const response=await createProductEnquiry(formData)

      console.log("response after submittingjob",response);
      toast.success("Enquiry submitted successfully!");
      
    } catch (error) {
      console.error("Enquiry submission failed:", error);
      toast.error("Failed to submit enquiry. Please try again.");
    }
  }


  return (
    <div>
      <Header />
      <div className="enquiry-wrapper flex gap-2">
         {/* <div>
            <p onClick={()=>setStep(5)} className=" rounded-lg shadow-lg p-2">Create Partnership</p>
            <p onClick={()=>setStep(4)} className=" rounded-lg shadow-lg p-2">Job Enquiry</p>
            <p onClick={()=>setStep(6)} className=" rounded-lg shadow-lg p-2">Product Enquiry</p>
          </div> */}
        <div className="enquiry-container">

         
       

          {step === 1 && (
            <div className="step">
              <input
                type="tel"
                placeholder="Enter Phone Number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              <button onClick={handleSendPhone}>Send OTP</button>
            </div>
          )}

          {step === 2 && (
            <div className="step otp-step">
              <div className="otp-inputs">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => {
                      const newOtp = [...otp];
                      newOtp[index] = e.target.value;
                      setOtp(newOtp);
                    }}
                  />
                ))}
              </div>
              <button onClick={handleVerifyOtp}>Verify OTP</button>
            </div>
          )}

          {step === 3 && (
            <div className="step">
              <h3>Fill Your Details</h3>
              <div className="form-grid">
                {Object.keys(formData).map((field) => (
                  <input
                    key={field}
                    name={field}
                    placeholder={field.replace(/([A-Z])/g, " $1")}
                    value={formData[field]}
                    onChange={handleInputChange}
                  />
                ))}
              </div>
              <button onClick={handleSubmitForm}>Submit Enquiry</button>
            </div>
          )}

          {step === 4 && (
            <div className="step">
              <h3>Submit Cover letter</h3>
              <textarea
                rows="4"
                placeholder="Type your enquiry or product-related question here..."
                value={coverLetter}
                onChange={(e) =>
                  setCoverLetter(e.target.value)
                }
                className="enquiry-textarea"
              />
              <p>Select your resume</p>
              <input type="file"  onChange={(e)=>setResume(e.target.files[0])}/>
              <button
                onClick={() => {
                  
                 handleSubmitEnquiry()
                  console.log(coverLetter,resume);
                  
                 
                }}
              >
                Submit
              </button>
            </div>
          )}
         
          
          {step === 6 && (
            <div className="step">
              <h3>Submit Enquiry</h3>
              <textarea
                rows="4"
                placeholder="Type your enquiry or product-related question here..."
                value={produtEnquiry}
                onChange={(e) =>
                  setProdutEnquiry(e.target.value)
                }
                className="enquiry-textarea"
              />
              <p>Select your prescription</p>
              <input type="file"  onChange={(e)=>setPresription(e.target.files[0])}/>
              <button
                onClick={() => {
                  
                handleProductEnquiry()
                  console.log(produtEnquiry,prescription);
                  
                 
                }}
              >
                Submit
              </button>
            </div>
          )}
        </div>
      </div>
      
      <Footer/>
    </div>
  );
};

export default EnqueryPage;
